/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Matchstyles } from './matchstyles';

const viewBox = [0, 0, 274, 84];

const path165x32 =
  'M165,0H6.1326l-0.0461,0.0922c0,0-2.3977,4.2882-4.2882,14.6628c-0.9683,4.9798-1.3833,9.268-1.6138,12.3112 C0.0922,28.5879,0.0461,29.7867,0,30.6167c0,0.415,0,0.7378,0,0.9683V31.8156c0,0.0461,0,0.0461,0,0.0461l0,0l0,0V32h158.8674 l0.0461-0.0922c0,0,2.3977-4.2882,4.2882-14.6628c0.9683-4.9798,1.3833-9.268,1.6138-12.3112c0.0922-1.5216,0.1383-2.7205,0.1844-3.5504 c0-0.415,0-0.7378,0-0.9683V0.1383l0,0V0z';

const textStyles = {
  fill: '#f0f0f0',
  fontFamily: 'SBS Sans, sans-serif',
  fontStretch: 'condensed',
};

function splitCountryName(countryName) {
  if (countryName === 'Bosnia and Herzegovina') {
    return ['Bosnia and', 'Herzegovina'];
  }
  if (countryName === 'Korea Republic') {
    return ['Korea', 'Republic'];
  }
  return [countryName];
}

function getResultStyles(result) {
  if (result === 'Win') {
    return { background: '#fff', text: '#000' };
  }
  if (result === 'Lose') {
    return { background: '#ffe040', text: '#333' };
  }
  return { background: 'none', text: textStyles.fill };
}

const MatchCard = memo(function MatchCard({
  homeGoals,
  awayGoals,
  penaltyScoreHome,
  penaltyScoreAway,
  teamARef,
  teamBRef,
  teamAName,
  teamBName,
  id,
  homeResult,
  awayResult,
}) {
  // temp static data for now
  // teamARef = 't10332';
  // teamAName = 'Australia';
  // teamBRef = 't10332';
  // teamBName = 'South Korea';
  const teamANameLines = splitCountryName(teamAName);
  const teamBNameLines = splitCountryName(teamBName);
  const homeRowStyles = getResultStyles(homeResult);
  const awayRowStyles = getResultStyles(awayResult);
  const hasPenaltyShootout =
    penaltyScoreHome !== '' &&
    penaltyScoreAway !== '' &&
    penaltyScoreHome != null &&
    penaltyScoreAway != null;

  return (
    <>
      <svg
        width="274"
        height="184"
        className="match-svg"
        viewBox={viewBox.join(' ')}
      >
        <text
          x="137"
          y="25"
          textAnchor="middle"
          fontSize="18"
          fontWeight="700"
          fill="#ffe040"
          fontFamily="SBS Sans, sans-serif"
        >
          THIRD PLACE PLAYOFF
        </text>
        <g className="match" transform="translate(55, 40)">
          <g transform="translate(0, 4)">
            <path
              d={path165x32}
              fill={homeRowStyles.background}
              stroke="#fff"
              strokeWidth="1"
            />
          </g>

          <g transform="translate(0, 44)">
            <path
              d={path165x32}
              fill={awayRowStyles.background}
              stroke="#fff"
              strokeWidth="1"
            />
          </g>

          <text
            x="58"
            y={teamANameLines.length > 1 ? 18 : 25}
            textAnchor="start"
            fontSize={teamANameLines.length > 1 ? 15 : 16}
            fontWeight="500"
            style={{ ...textStyles, fill: homeRowStyles.text }}
          >
            {teamANameLines.map((line, index) => (
              <tspan
                key={`${id}-teamA-${line}`}
                x="58"
                dy={index === 0 ? 0 : 13}
              >
                {line}
              </tspan>
            ))}
          </text>

          <text
            x="58"
            y={teamBNameLines.length > 1 ? 58 : 65}
            textAnchor="start"
            fontSize={teamBNameLines.length > 1 ? 15 : 16}
            fontWeight="500"
            style={{ ...textStyles, fill: awayRowStyles.text }}
          >
            {teamBNameLines.map((line, index) => (
              <tspan
                key={`${id}-teamB-${line}`}
                x="58"
                dy={index === 0 ? 0 : 13}
              >
                {line}
              </tspan>
            ))}
          </text>
          {homeGoals !== undefined && (
            <text
              x="156"
              y="25"
              textAnchor="end"
              fontSize="16"
              fontWeight="500"
              style={{ ...textStyles, fill: homeRowStyles.text }}
            >
              {homeGoals}
            </text>
          )}
          {hasPenaltyShootout ? (
            <>
              <text
                x="146"
                y="25"
                textAnchor="end"
                fontSize="14"
                fontWeight="400"
                style={{ ...textStyles, fill: homeRowStyles.text }}
              >
                ({penaltyScoreHome})
              </text>
              <text
                x="146"
                y="65"
                textAnchor="end"
                fontSize="14"
                fontWeight="400"
                style={{ ...textStyles, fill: awayRowStyles.text }}
              >
                ({penaltyScoreAway})
              </text>
            </>
          ) : null}

          {awayGoals !== undefined && (
            <text
              x="156"
              y="65"
              textAnchor="end"
              fontSize="16"
              fontWeight="500"
              style={{ ...textStyles, fill: awayRowStyles.text }}
            >
              {awayGoals}
            </text>
          )}
        </g>
      </svg>

      <div className="flag-wrap">
        {teamARef !== undefined ? (
          <img
            src={`images/${teamARef}.png`}
            alt={`Team ${teamAName} flag`}
            style={{
              position: 'absolute',
              left: 55,
              top: 94,
              width: 53,
              height: 'auto',
            }}
          />
        ) : null}

        {teamBRef !== undefined ? (
          <img
            src={`images/${teamBRef}.png`}
            alt={`Team ${teamBName} flag`}
            style={{
              position: 'absolute',
              left: 55,
              top: 134,
              width: 53,
              height: 'auto',
            }}
          />
        ) : null}
      </div>
    </>
  );
});

export default function ThirdPlacePlayoff({
  positions,
  homeGoals,
  awayGoals,
  penaltyScoreHome,
  penaltyScoreAway,
  teamARef,
  teamBRef,
  teamAName,
  teamBName,
  id,
  homeResult,
  awayResult,
}) {
  const activeButton = useSelector((state) => state.data.activeButton);

  const { x = 0, y = 0 } = positions?.[activeButton] || {};

  const centeredX =
    activeButton === 'final' ? (window.innerWidth - 276) * 0.5 : x;

  const stylePos = {
    transform: `translate(${centeredX}px, ${y}px)`,
  };

  return (
    <Matchstyles>
      <div className="match-wrap" style={stylePos}>
        <MatchCard
          homeGoals={homeGoals}
          awayGoals={awayGoals}
          penaltyScoreHome={penaltyScoreHome}
          penaltyScoreAway={penaltyScoreAway}
          teamARef={teamARef}
          teamBRef={teamBRef}
          teamAName={teamAName}
          teamBName={teamBName}
          id={id}
          homeResult={homeResult}
          awayResult={awayResult}
        />
      </div>
    </Matchstyles>
  );
}
